import React from "react";

import { Border, IndentSelect, ThemeSelect } from "@tableplus/toolkit";
import { Prefs } from "prefs/prefs";
import { DivPx } from "@moai/core";
import { SaveMenu } from "../save/save";

import s from "./more.module.scss";

interface Props {
    getValue: () => string | null;
    prefs: Prefs;
}

export const MorePane: React.FC<Props> = (props) => {
    const { prefs, getValue } = props;
    const { indent, setIndent, theme, setTheme } = prefs;
    return (
        <div className={s.container}>
            <DivPx size={16} />
            <SaveMenu getValue={getValue} />
            <DivPx size={16} />
            <Border color="strong" />
            <DivPx size={16} />
            <IndentSelect fullWidth indent={indent} setIndent={setIndent} />
            <DivPx size={16} />
            <ThemeSelect theme={theme} setTheme={setTheme} />
        </div>
    );
};
